import React from 'react';
import PropTypes from 'prop-types';
import { getParsedFormErrorParameters } from 'utils';

import { Icon, Label } from '@atlas/ui';

const GlobalErrors = ({ globalErrors = [] }) => {
  if (!globalErrors || !globalErrors.length) {
    return null;
  }

  const renderErrors = globalErrors.map(error => {
    const { message, traceId, type, violationInfo } = error;

    const errorContent = type ? (
      <Label
        className="main-label"
        message={message}
        params={getParsedFormErrorParameters(violationInfo)}
      />
    ) : (
      message
    );

    return (
      <div className="notification-item" key={traceId}>
        <div className="notification-item-icon">
          <Icon className="icon-error" name="error" />
        </div>
        <div className="notification-item-text">{errorContent}</div>
      </div>
    );
  });

  return <div className="form-global-errors">{renderErrors}</div>;
};

GlobalErrors.propTypes = { globalErrors: PropTypes.array };

export default GlobalErrors;
